import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

type Props = {
    open: boolean;
    courseTitle: string;
    deleting: boolean;
    onCancel: () => void;
    onConfirm: () => void;
};

// A published course cannot be deleted at all, and the server says so.
export default function ConfirmDeleteCourseDialog({ open, courseTitle, deleting, onCancel, onConfirm }: Props) {
    return (
        <Dialog open={open} onClose={onCancel} maxWidth="sm">
            <DialogTitle>Delete this course?</DialogTitle>

            <DialogContent>
                <DialogContentText>{`You sure you want to delete "${courseTitle}"?`}</DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button onClick={onCancel} disabled={deleting}>
                    Cancel
                </Button>
                <Button variant="contained" color="secondary" onClick={onConfirm} disabled={deleting}>
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
}
